import templateUrl from './shiftsExportOptions.html';

class ShiftsExportOptionsCtrl {
  constructor(Authentication) {
    'ngInject';

    Object.assign(this, { Authentication });
  }

  get clientFlags() {
    return this.Authentication.user.settings.clientFlags;
  }

  $onInit() {
    this.options = {
      showScheduleEndTimes: this.clientFlags.printShowScheduleEndTimes,
      showShiftNotes: this.clientFlags.exportShiftNotes,
    };
  }

  showShiftNotesChanged() {
    // this.clientFlags.exportShiftNotes = this.options.showShiftNotes;
    // this.Authentication.syncSettings();
    this.Authentication.saveClientFlags({
      exportShiftNotes: this.options.showShiftNotes,
    });
  }

  showScheduleEndTimesChanged() {
    this.clientFlags.printShowScheduleEndTimes = this.options.showScheduleEndTimes;
    this.Authentication.syncSettings();
  }
}

export default {
  templateUrl,
  controller: ShiftsExportOptionsCtrl,
  controllerAs: 'ctrl',
  bindings: {
    type: '@',
    $close: '&close',
    $dismiss: '&dismiss',
  },
};
